// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.stamp-svg {
  position: fixed;
  bottom: 0;
  right: 0;
  height: 20vh;
  z-index: 10;
  pointer-events: none;
  transform: translate(30%);
  opacity: 0.15;
}

.rotating {
  animation: rotate 80s infinite linear;
}

.mobile-stamp {
  position: absolute;
  bottom: -15px;
  right: -50px;
  height: auto;
  pointer-events: none;
  opacity: 0.05;
  z-index: -1;
}

.mobile-stamp svg {
  width: 250px;
  height: 250px;
}

@media (max-width: 768px) {
  .stamp-svg {
    display: none;
  }
}

@media (min-width: 769px) {
  .mobile-stamp {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/base/stamp.css"],"names":[],"mappings":"AAAA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.stamp-svg {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  height: 20vh;\n  z-index: 10;\n  pointer-events: none;\n  transform: translate(30%);\n  opacity: 0.15;\n}\n\n.rotating {\n  animation: rotate 80s infinite linear;\n}\n\n.mobile-stamp {\n  position: absolute;\n  bottom: -15px;\n  right: -50px;\n  height: auto;\n  pointer-events: none;\n  opacity: 0.05;\n  z-index: -1;\n}\n\n.mobile-stamp svg {\n  width: 250px;\n  height: 250px;\n}\n\n@media (max-width: 768px) {\n  .stamp-svg {\n    display: none;\n  }\n}\n\n@media (min-width: 769px) {\n  .mobile-stamp {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
